// Ledgy import adapter — PSD §10.1 (F10.1). Integration layer.

import type { CapTable } from '@backsolve/shared-types';
import { ulid } from '@/id';
import { parseJsonOrCsv, buildInstrument, type CsvRow } from './_shared';

export interface ParsedImport {
  capTable: CapTable;
  warnings: string[];
}

export function parseLedgyImport(file: string, entityName: string): ParsedImport {
  const rows = parseJsonOrCsv(file);
  const instruments = rows.map((row: CsvRow) =>
    buildInstrument(row, {
      name: ['stakeholder', 'holder', 'name', 'transaction partner'],
      kind: ['type', 'instrument', 'instrument type'],
      shares: ['shares', 'quantity', 'amount', 'nominal value'],
      authorized: ['authorized', 'total shares', 'shares'],
      issuePrice: ['price', 'issue price', 'purchase price', 'nominal price per share'],
      issueDate: ['date', 'issue date', 'transaction date'],
      liquidationMultiple: ['liquidation preference', 'preference'],
      strikePrice: ['exercise price', 'strike price', 'strike'],
    }),
  );
  return {
    capTable: {
      id: `cap_${ulid()}`,
      entityName,
      asOfDate: new Date().toISOString().slice(0, 10),
      instruments,
      convertibles: [],
      currency: 'USD',
      version: 1,
    },
    warnings: [],
  };
}

export async function parseImport(file: File, entityName: string): Promise<ParsedImport> {
  return parseLedgyImport(await file.text(), entityName);
}
